import React from 'react';
import useMedia from "use-media";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { textInResolution, textInResolutionMobile } from '../multiFunctions';
import NewsLetterRegister from '../components/newsLetterRegister';
import './footer.css';

function Footer(props) {
  /* eslint-disable jsx-a11y/anchor-is-valid */
  /* eslint-disable react/prop-types */
  let isSubscribeVisible = true;
  if (props.isSubscribeVisible !== undefined && !props.isSubscribeVisible) {
    isSubscribeVisible = false;
  }
  let screenSize = {
    width: window.screen.width,
    height: window.screen.height
  }
  const isLargeScreen = useMedia("(min-width: 601px)");
  const isSmallScreen = useMedia("(max-width: 600px)");
  let drawLine = {
    borderBottom: "1px solid white",
    paddingBottom: "10px"
  }
  let styleIconPages = {
    fontSize: textInResolution("large", "x-large", "xx-large", "xx-large", screenSize),
    paddingRight: "10px"
  }
  let styleIconPagesMobile = {
    fontSize: textInResolutionMobile("large", "x-large", "x-large", screenSize),
    paddingRight: "10px"
  }
  let nowDate = new Date().getFullYear();
  return (
    <>
      {isLargeScreen &&
        <div style={{ backgroundColor: '#0C344B',color: "white", textAlign: "center", justifyContent: "center",  width: "100%", display: "flex" }}>
          <div style={{ maxWidth: "1200px", width: "100%" }}>
            <div style={{ width: "100", ...drawLine, paddingTop: "10px" }}></div>
            <div style={{ display: "flex", flexFlow: "row", width: "100%", paddingTop: "10px" }}>
              <div style={{ width: "40%" }}>
                <NewsLetterRegister isDiscount={false} isSubscribeVisible={isSubscribeVisible}/>
              </div>
              <div className="parent-div">
                <a className="urlStyle" ><p>Login / Signup</p></a>
                <p>Contact us</p>
                <a className="urlStyle" href='/policy'><p>Policies</p></a>
              </div>
              <div className="parent-div">
                <p>Tips</p>
                <a className="urlStyle" href='/perfectCoffee'><p>Your Perfect Coffee</p></a>
                <a className="urlStyle" href='/customizeYourOrder'><p>Customize</p></a>
              </div>
              <div className="parent-div">
                <a className="urlStyle" href='/localfarms'><p>Local Farms</p></a>
                <a className="urlStyle" href='/specialtyCoffee'><p>Specialty Coffee</p></a>
                <a className="urlStyle" href='/ourCoffee'><p>Our Coffee</p></a>
              </div>
            </div>
            <div style={{ width: "100", ...drawLine }}></div>
            <div style={{ width: "100%", display: "flex", flexFlow: "row",justifyContent: "space-around", paddingTop: "10px" }}>
              <div>
                  <span>Copyright for OutboxIT © {nowDate}<br/></span>
                  <span><img src='./img/companyLogo.png' style={{ maxHeight:'15px', maxWidth: '15px' }}  alt="Cafe Roots"/> by Cafe-Roots, LLC.</span>
              </div>
              <div>
                <a href='https://www.instagram.com/caferootshn/' style={{ color: 'white' }} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon style={styleIconPages} icon={faInstagram} />
                </a>
                <a href='https://www.facebook.com/profile.php?id=61573022394744' style={{ color: 'white' }} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon style={styleIconPages} icon={faFacebook} />
                </a>
              </div>
            </div>
          </div>
        </div>
      }
      {isSmallScreen &&
      <div style={{ backgroundColor: '#0C344B',color: "white", textAlign: "center", justifyContent: "center",  width: "100%", display: "flex" }}>
        <div style={{ display: "flex", flexFlow: "column", width: "100%", paddingTop: "10px",maxWidth: "1200px", }}>
          <div className='parent-div-Movil' style={{ paddingBottom: "10px" }}>
            <NewsLetterRegister isDiscount={false} isSubscribeVisible={isSubscribeVisible}/>
          </div>
          <div className='parent-div-Movil'>
             <a className="urlStyle" ><p>Login / Signup</p></a> 
            <p>Contact us</p>
            <a className="urlStyle" href='/policy'><p>Policies</p></a>
          </div>
          <div className='parent-div-Movil'>
            <p>Tips</p>
            <a className="urlStyle" href='/perfectCoffee'><p>Your Perfect Coffee</p></a>
            <a className="urlStyle" href='/customizeYourOrder'><p>Customize</p></a>
          </div>
          <div className='parent-div-Movil'>
            <a className="urlStyle" href='/localfarms'><p>Local Farms</p></a>
            <a className="urlStyle" href='/specialtyCoffee'><p>Specialty Coffee</p></a>
            <a className="urlStyle" href='/ourCoffee'><p>Our Coffee</p></a>
          </div>
          <div>
              <span>Copyright for OutboxIT © {nowDate}<br/></span>
              <span><img src='./img/companyLogo.png' style={{ maxHeight:'20px', maxWidth: '20px' }}  alt="Cafe Roots"/> by Cafe-Roots, LLC.</span>
          </div>
          <div style={{ paddingTop: "10px" }}>
            <FontAwesomeIcon style={styleIconPagesMobile} icon={faInstagram} />
            <FontAwesomeIcon style={styleIconPagesMobile} icon={faFacebook} />
            <FontAwesomeIcon style={styleIconPagesMobile} icon={faXTwitter} />
          </div>
        </div>
      </div>
      }
    </>
    );
  }
  
  export default Footer;